import { createSelector } from 'reselect';

import { getEnvVar } from '../utils/env';

const getRtlLanguages = getEnvVar('R2L_LANGUAGES') ?? [];

const selectAuth = (state) => state.auth;

export const selectIsLogonUserChanged = createSelector(
  selectAuth,
  (auth) => !!auth?.isLogonUserChanged
);

export const selectUserName = createSelector(selectAuth, (auth) => auth?.username || '');

export const selectIsSSOLoginFailure = createSelector(
  selectAuth,
  (auth) => !!auth?.isSSOLoginFailure
);

export const selectShowSignOffDialog = createSelector(
  selectAuth,
  (auth) => !!auth?.showSignOffDialog
);

export const selectLoginMethod = createSelector(selectAuth, (auth) => auth?.loginMethod || false);

export const selectSessionExpirationErrorCode = createSelector(
  selectAuth,
  (auth) => auth?.sessionExpirationErrorCode || localStorage.getItem('sessionExpirationErrorCode')
);

export const selectShowFEDSSOPopup = createSelector(selectAuth, (auth) => !!auth?.showFEDSSOPopup);

export const selectIsTokenUpdated = createSelector(selectAuth, (auth) => !!auth?.isTokenUpdated);

export const getLanguage = createSelector(selectAuth, (auth) => auth?.culture || '');

export const getIsRtlLanguage = createSelector(getLanguage, (lang) =>
  getRtlLanguages.includes(lang)
);

export const getIsArchiveMode = createSelector(selectAuth, (auth) => !!auth?.isArchiveMode);

export const getSmartInsightApplicationURL = createSelector(
  selectAuth,
  (auth) => auth.smartInsightApplicationURL
);
